import React from 'react';
import { Layout } from '../components/sections/Layout';
import { PlatformOverview } from '../components/sections/PlatformOverview';
import { AvailableTodaySection } from '../components/sections/AvailableTodaySection';
import { FinalCTA } from '../components/sections/FinalCTA';
export function PlateformePage() {
  return <Layout data-id="element-818">
      <PlatformOverview data-id="element-819" />
      <AvailableTodaySection data-id="element-820" />
      <FinalCTA data-id="element-821" />
    </Layout>;
}